module.exports = __webpack_public_path__ + "b4087660d7d147e200000885a79461ce.vtt";